import { ReactNode } from "react";
import { cn } from "../helper/classNames";

interface CustomLabelProps {
  label: string | undefined | ReactNode;
  required: boolean | undefined;
  className?: string;
}

const CustomLabel = (props: CustomLabelProps) => {
  const { label, required, className } = props;
  return (
    <p className={cn("font-primary text-xs font-normal mb-1 text-primary-dark", className)}>
      {required ? (
        <>
          {label}
          <span className={"text-red"}>*</span>
        </>
      ) : (
        label
      )}
    </p>
  );
};

export default CustomLabel;
